import { render, staticRenderFns } from "./MyCart.vue?vue&type=template&id=2e5c1a86&"
import script from "./MyCart.vue?vue&type=script&lang=js&"
export * from "./MyCart.vue?vue&type=script&lang=js&"
import style0 from "./MyCart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports